import React from 'react';
import { PropInfo, CodeExample, ButtonProps } from '@cimpress/react-components';
import ButtonCode from '!raw-loader!./button.jsx';
import ButtonDemo from './button.jsx';
import IconButtonCode from '!raw-loader!./IconButton';
import IconButtonDemo from './IconButton';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const ButtonDocs = () => {
  const propInfos: PropInfo<ButtonProps>[] = [
    {
      name: 'href',
      type: 'string',
      description: 'The ability to make the button navigate to a url',
      default: '#',
    },
    {
      name: 'target',
      type: 'string',
      default: '',
      description: 'Specify the behavior of button navigation',
    },
    {
      name: 'variant',
      type: 'string',
      default: 'default',
      description: (
        <div>
          The variant of button you are creating, providing one of the following values:
          <ul>
            <li>default</li>
            <li>primary</li>
            <li>secondary</li>
            <li>link</li>
            <li>outline-secondary</li>
          </ul>
        </div>
      ),
    },
    {
      name: 'size',
      type: 'string',
      description: (
        <div>
          The size of the button you are creating, providing one of the following values:
          <ul>
            <li>default</li>
            <li>sm</li>
            <li>lg</li>
          </ul>
        </div>
      ),
      default: 'default',
    },
    {
      name: 'onClick',
      type: 'function',
      default: '',
      description: 'The callback function used when a button is clicked',
    },
    {
      name: 'disabled',
      type: 'boolean',
      default: 'false',
      description: 'The ability to disable the button',
    },
    {
      name: 'blockLevel',
      type: 'boolean',
      default: 'false',
      description: 'The ability to make the button fill the content block',
    },
    {
      name: 'children',
      type: 'node',
      default: '',
      description: 'The inner contents of the button',
    },
  ];

  return (
    <ComponentDoc<ButtonProps> name="Button" propInfos={propInfos}>
      <ButtonDemo />
      <CodeExample code={ButtonCode} />
      <IconButtonDemo />
      <CodeExample code={IconButtonCode} />
    </ComponentDoc>
  );
};

export default ButtonDocs;
